"use client";

import React from "react";

export default function SectionPage() {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden", margin: 0, padding: 0, background: "#000" }}>
      <iframe
        src="/models/section.html"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        title="Creator Economy - Creator Communities"
      />
    </div>
  );
}
